// extracted by mini-css-extract-plugin
export default {"zoomControls":"Mca-z","zoomControlButton":"Nca-z","zoomBanner":"Oca-z","bannerButton":"Pca-z","imageButton":"Qca-z","zoom":"Rca-z","zoomContent":"Sca-z"};